<template lang="pug">
.filters-placeholder
  .filter-group(v-for="group in GROUPS" :key="group")
    .label-bar
    .option-row(v-for="row in ROWS" :key="row")
</template>

<script setup lang="ts">
const GROUPS = 4
const ROWS = 5
</script>

<style lang="scss" scoped>
@keyframes skeleton-loading {
  0% { background-color: $color-gray-x-light; }
  100% { background-color: $color-gray-light; }
}

.filter-group {
  padding: $space-s 0;
  border-bottom: $border-width-thin solid $color-gray-light;
}

.label-bar,
.option-row {
  border-radius: $radius-default;
  animation: skeleton-loading 1s linear infinite alternate;
}

.label-bar {
  height: $space-s;
  width: 60%;
  margin-bottom: $space-s;
}

.option-row {
  height: $size-xs;
  width: 80%;
  margin-bottom: $space-xs;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
